import { useQuery } from '@tanstack/react-query';

import {
  getCurrentBrokerOfTheUser,
  type GetCurrentBrokerOfTheUserResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import queryKeys from '@/queries/queryKeys';
import type { QueryOptions } from '@/types/react-query';

export default function useCurrentBroker(
  options?: QueryOptions<GetCurrentBrokerOfTheUserResponse>,
) {
  return useQuery({
    queryKey: queryKeys.brokers.me(),
    queryFn: () => getCurrentBrokerOfTheUser(wgApi),
    ...options,
  });
}
